import React from 'react';
import { Grid } from '@beeline.com/bp-design-system';
import AppLink from 'common/AppLink/AppLink';
import SupplierAvatar from 'common/avatars/SupplierAvatar';
import { SupplierModel } from '@utmost.co/enterprise-models';

interface Props {
  supplier?: SupplierModel;
  dataTest?: string;
}

const SupplierDetails: React.FC<React.PropsWithChildren<Props>> = ({ supplier, dataTest = '' }) => (
  <>
    {supplier ? (
      <Grid container spacing={1} alignItems="center">
        <Grid>
          <SupplierAvatar size="xs" supplier={supplier} />
        </Grid>
        <Grid>
          <div style={{ marginTop: 3 }} data-test={`${dataTest}-link`}>
            <AppLink url={`/supplier/${supplier?.uid}`} data-test="user-name">
              {supplier?.name}
            </AppLink>
          </div>
        </Grid>
      </Grid>
    ) : (
      '-'
    )}
  </>
);

export default SupplierDetails;
